export default __webpack_public_path__ + "static/media/thankyouBannerNewMobile.d55d7fb8.png";